import { downloadCsv, escapeCsvField } from './deviceQueueCsv';

export function buildSsoLogCsv(headers: string[], rows: string[][]): string {
  const headerLine = headers.map(escapeCsvField).join(';');
  const dataLines = rows.map((row) => row.map((cell) => escapeCsvField(cell ?? '')).join(';'));
  return [headerLine, ...dataLines].join('\r\n');
}

export function ssoLogCsvFilename(now = new Date()): string {
  const stamp = now.toISOString().slice(0, 10);
  return `sso-logg-${stamp}.csv`;
}

export function downloadSsoLogCsv(filename: string, csv: string): void {
  downloadCsv(filename, csv);
}
